var map = {
	"./1.jpg": 16741,
	"./10.png": 65265,
	"./3.png": 45754,
	"./4.jpg": 64028,
	"./5.jpg": 82693,
	"./6.jpg": 72812,
	"./7.png": 47783,
	"./8.png": 65166,
	"./9.png": 22102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50900;